import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { isFirstItemUntouched } from './useBillItems.utils';
const BillItemsContext = /*#__PURE__*/ createContext(null);
export function BillItemsProvider(param) {
    let { onBeforeRemoveItem, children } = param;
    const { control, getValues } = useFormContext();
    const { fields, append, remove, move, update } = useFieldArray({
        control,
        name: 'items',
        keyName: 'fieldId'
    });
    const value = useMemo(()=>({
            fields,
            appendItem: (item)=>append(item),
            replaceItem: (index, item)=>update(index, item),
            removeItem: (index)=>{
                onBeforeRemoveItem === null || onBeforeRemoveItem === void 0 ? void 0 : onBeforeRemoveItem(index);
                remove(index);
            },
            moveItem: (from, to)=>move(from, to),
            removeFirstItemIfUntouched: ()=>{
                if (isFirstItemUntouched(getValues('items'))) remove(0);
            }
        }), [
        fields,
        append,
        update,
        remove,
        move,
        getValues,
        onBeforeRemoveItem
    ]);
    return /*#__PURE__*/ _jsx(BillItemsContext.Provider, {
        value: value,
        children: children
    });
}
export function useBillItems() {
    const context = useContext(BillItemsContext);
    if (!context) throw new Error('useBillItems must be used within a BillItemsProvider');
    return context;
}
